// src/application/hooks/useAddCompany.js
import { useState } from 'react';
import { ApiUserRepository } from '../../infrastructure/repositories/ApiUserRepository';
import { LoginLogoutAction } from '../UseCase/LoginLogoutAction';
import userApiClient from '../../infrastructure/userApiClient';
import useApiClient from '../../infrastructure/apiClient';



export const useLoginLogout = () => {
  
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const apiClient = useApiClient();

  const LoginLogout = async (action) => {
    debugger;
    const userRepository = new ApiUserRepository(userApiClient,apiClient);
    const LoginLogoutActionUseCase = new LoginLogoutAction(userRepository);

    try {
      debugger;
      setLoading(true);     
      await LoginLogoutActionUseCase.execute(action);
    } catch (err) {
      setError(err.message);
    }
    finally{
      debugger;
      setLoading(false);
      console.log(loading);
    }
  };

  return {LoginLogout, error, loading };
};
export default useLoginLogout;
